"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setReturnToUrlCookie = void 0;
const core_utility_1 = require("@built/core-utility");
const logging_1 = require("../logging");
const REDIRECT_COOKIE_NAME = 'builtRedirect';
/**
 * Sets cookie that our front end auth app uses to determine where to send the user after signing in.
 *
 * This will be set automatically (by default) when calling `signOut`.
 */
const setReturnToUrlCookie = (options) => {
    const { returnToUrl = window.location.href, env, apps, domain } = options || {};
    const cookieValue = {
        url: returnToUrl,
        env,
        apps,
    };
    (0, logging_1.verbose)(`Setting return to URL cookie (${REDIRECT_COOKIE_NAME}):`, cookieValue);
    core_utility_1.Cookies.set(REDIRECT_COOKIE_NAME, JSON.stringify(cookieValue), {
        domain: domain,
        expires: 1,
        secure: true,
    });
};
exports.setReturnToUrlCookie = setReturnToUrlCookie;
